import { Form, Input, Select } from "antd";
import Modal from "antd/es/modal/Modal";
import { t } from "i18next";
import { SystemTermsModel } from "models/systemTerms";
import { SetStateAction, useEffect, useState } from "react";

const UpdateSystemTermModal = ({
  open,
  setOpen,
  item,
  isLoading,
  onUpdate,
}: {
  open: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  item: SystemTermsModel | undefined;
  isLoading: boolean;
  onUpdate: ({ data, id }: any) => void;
}) => {
  const [form] = Form.useForm();

  const handleClose = () => {
    setOpen(false);
  };

  const onFinish = (e: any) => {
    const formData = new FormData();

    formData.append("name_ar", e.name_ar);
    formData.append("name_en", e.name_en);
    formData.append("type", e.type);
    formData.append("_method", "PUT");

    onUpdate({ id: item?.id, data: formData });
  };

  useEffect(() => {
    form.setFieldValue("name_ar", item?.name_ar);
    form.setFieldValue("name_en", item?.name_en);
    form.setFieldValue("type", item?.type);
  }, [open]);

  return (
    <Modal
      open={open}
      width={400}
      title={t("edit_system_term")}
      centered
      destroyOnClose
      bodyStyle={{ padding: 20 }}
      onCancel={() => handleClose()}
      onOk={() => {
        form.submit();
      }}
      confirmLoading={isLoading}
    >
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={{
          name_ar: item?.name_ar,
          name_en: item?.name_en,
          type: item?.type,
        }}
        labelCol={{ span: 24 }}
        validateMessages={{
          required: t("please_input") + " ${label}!",
        }}
      >
        <Form.Item
          name={"name_ar"}
          label={t("arabic_name")}
          rules={[{ required: true }]}
          required
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={"name_en"}
          label={t("english_name")}
          rules={[{ required: true }]}
          required
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="type"
          label={t("type")}
          rules={[{ required: true }]}
          required
          initialValue={item?.type}
        >
          <Select>
            <Select.Option value="in">{t("in_system_terms")}</Select.Option>
            <Select.Option value="out">{t("out_system_terms")}</Select.Option>
            <Select.Option value="both">{t("both_system_terms")}</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateSystemTermModal;
